export const APP = "app";
export const CREDIT = "credit";
export const APP_ENTRY = "app-entry";
export const APPLICATION_REVIEW = "app-review";
export const PRE_CREDIT_REVIEW = "precredit-review";
export const ASSET = "asset";
export const ASSET_REVIEW = "asset-review";
export const CREDIT_REVIEW = "credit-review";
export const CREDIT_ADJUDICATION = "credit-adjudication";
export const DEAL = "dealmaker";
export const DEAL_STRUCTURE = "deal-structure";
export const DEAL_MAKER = "deal-maker";
export const DOCUMENT = "document";
export const DOCUMENT_DATA_REVIEW = "document-data-review";
export const DOCUMENTS_SENT = "document-sent";
export const DOCUMENT_REVIEW = "document-review";
export const VERBAL = "verbal";
export const VERBAL_DNA = "verbal-dna";
export const DASHBOARD = "dashboard";
export const FUNDING = "funding";
export const FUNDING_REVIEW = "funding-review";
export const FUNDED_CONFIRMATION = "funded-confirmation";
export const ADMIN = "admin-console";
export const ADMIN_CONSOLE = "admin-console";
